import axiosClient from "../requests/axiosCLient";
import { API_URLS } from "../../constants/constants";

export const getMenuDetails = () => {
  const url = API_URLS.menuEndPoint;
  return axiosClient.get(url);
};
